import authServiceReducer from 'modules/auth/services/reducers';
import channelServiceReducer from 'modules/channel/services/reducers';
import dashboardServiceReducer from 'modules/dashboard/services/reducers';
import mediaServiceReducer from 'modules/media/services/reducers';
import storeServiceReducer from 'modules/store/services/reducers';
import playlistServiceReducer from 'modules/playlist/services/reducers';

const rootReducer = {
  auth: authServiceReducer,
  dashboard: dashboardServiceReducer,
  channel: channelServiceReducer,
  media: mediaServiceReducer,
  store: storeServiceReducer,
  playlist: playlistServiceReducer,
};

export default rootReducer;
